import { useState, useCallback, useRef } from "react";
import { getData } from "../../../../services/library";
import { logEventos } from "../../../../services/services";
import { ORIGENES } from "../constants";

// Estadísticas sobre el conjunto visible (depende del switch de descartados)
export const calcularEstadisticas = (pedidos) => {
  const porOrigen = {};
  const porEstado = {};
  pedidos.forEach((p) => {
    const origen = p.origen || ORIGENES.SIN_ORIGEN;
    porOrigen[origen] = (porOrigen[origen] || 0) + 1;

    const valor = p.valor || "Sin estado";
    if (!porEstado[valor]) porEstado[valor] = { cantidad: 0, estado: p.estado };
    porEstado[valor].cantidad += 1;
  });
  return { total: pedidos.length, porOrigen, porEstado };
};

export const useTodosPedidos = () => {
  const [pedidos, setPedidos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const abortControllerRef = useRef(null);

  const obtenerPedidos = useCallback(async (desde, hasta) => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    abortControllerRef.current = new AbortController();
    setLoading(true);
    setError(null);

    try {
      const sucAuth = localStorage.getItem("suc_auth")?.split(",") || [];
      const url = `/envasado_pedidos/todossucauth/${desde} 00:00:00/${hasta} 23:59:59/${sucAuth.join(",")}`;

      const data = await new Promise((resolve, reject) => {
        getData(url, (result) => {
          if (result && Array.isArray(result)) {
            resolve(result);
          } else {
            resolve([]);
          }
        }, abortControllerRef.current.signal);
      });

      setPedidos(data);
    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error("Error:", err);
        setError("Error al cargar los pedidos");
      }
    } finally {
      setLoading(false);
    }
  }, []);

  // Solo log de acceso, sin fetch automático
  useState(() => {
    logEventos("acceso al menú Todos los Pedidos", "Envasado", "Todos los Pedidos", localStorage.getItem("user"));
  }, []);

  return {
    pedidos,
    loading,
    error,
    obtenerPedidos,
    setError
  };
};
